import { defineMessages } from 'react-intl';

const messages = defineMessages({
  carrierSharingConfigurationModalHeader: {
    defaultMessage: 'Carrier Sharing for {name}',
    id: 'JzeHQD',
    description: 'Carrier Sharing modal header',
  },
  saveChanges: {
    defaultMessage: 'Save Changes',
    id: 'VrHFmy',
    description: 'Save Changes button label',
  },
  carrierSharingCustomFetchErrorTitle: {
    defaultMessage: 'Error fetching shared carrier settings',
    id: '8A8GWX',
    description: 'Carrier Sharing configuration fetching error title',
  },
  carrierSharingCustomFetchError: {
    defaultMessage:
      'ShipStation could not fetch the shared services configuration. Please try again. If this error persists, please contact our support team.',
    id: 'H4XuHI',
    description: 'Carrier Sharing configuration fetching error',
  },
  defaultSettings: {
    defaultMessage: 'Default settings',
    id: 'Pf784e',
    description: 'Default settings radiobutton label',
  },
  customSettings: {
    defaultMessage: 'Custom settings',
    id: 'kK6SPw',
    description: 'Custom settings radiobutton label',
  },
  saveCarrierSharingErrorTitle: {
    defaultMessage: 'Error saving shared carrier settings',
    id: 'NYuapO',
    description: 'Error during custom carrier sharing saving title',
  },
  saveCarrierSharingError: {
    defaultMessage:
      'ShipStation could not save the shared services configuration. Please try again. If this error persists, please contact our support team.',
    id: '8UGkQl',
    description: 'Error during custom carrier sharing saving',
  },
  applyDefaultErrorTitle: {
    defaultMessage: 'Error applying shared carrier settings',
    id: '8Fzf35',
    description: 'Error applying shared carrier settings title',
  },
  applyDefaultError: {
    defaultMessage:
      'ShipStation could not apply the default shared services configuration. Please try again. If this error persists, please contact our support team.',
    id: 'Y/Ir7e',
    description: 'Error applying shared carrier settings',
  },
  carrierSharingValidationErrorBack: {
    description: 'Carrier sharing validation error back button text',
    defaultMessage: 'Back',
    id: 'jttOkm',
  },
  carrierSharingValidationErrorTitle: {
    description: 'Carrier sharing validation error modal title',
    defaultMessage: 'Shared Services Validation Error',
    id: 'Npd8fp',
  },
  carrierSharingValidationErrorMessage: {
    description: 'Carrier sharing validation error modal message',
    defaultMessage: 'ShipStation cannot share services from multiple accounts. Please select the shared services from a single account.',
    id: '9DvGbC',
  },
  lastChangedDateModalMessage: {
    description: 'Carrier Sharing last custom configuration change date message',
    defaultMessage: 'Last custom configuration change: {modificationDate}',
    id: '0/1npC',
  },
});
export default messages;
